var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('reset-password-form',{attrs:{"form-name":"reset_password_form","fixed-data":_vm.fixedData}})}
var staticRenderFns = []

export { render, staticRenderFns }